<div class="wrapper">
  <!-- GPS Geometry overview map above quantity (hidden when map is showing geometries) -->
  @if (showMiniMaps && allEntriesMapGeometry) {
    <div class="survey_data-map border h-[80px] mb-[20px] rounded-[8px]">
      <app-survey-data-map [geometry]="allEntriesMapGeometry" (open3d)="openAllEntriesVolume3d($event.featureIndex)" />
    </div>
  }
  <div class="total-section flex flex-col">
    <div class="quantity-total-label text-type-14">QUANTITY:</div>
    <div
      class="quantity-total-value text-type-11">{{ quantityTotal | number: '1.0-' + (bidItem?.quantity_rounding ?? 2) }}
    </div>
    @if (getCapacity() != null) {
      <div class="consumption-info text-[13px] text-[#60698B] mt-[8px]">
        @if (getRemaining() >= 0) {
          {{ getRemaining() | number: '1.0-' + (bidItem?.quantity_rounding ?? 2) }} of {{ getCapacity() | number: '1.0-' + (bidItem?.quantity_rounding ?? 2) }} remaining
        } @else {
          <span class="text-[#E53935]">
            0 of {{ getCapacity() | number: '1.0-' + (bidItem?.quantity_rounding ?? 2) }} remaining, {{ getOverLimit() | number: '1.0-' + (bidItem?.quantity_rounding ?? 2) }} over limit
          </span>
        }
      </div>
    }
  </div>
  <div class="section-separator"></div>
  <div class="line-items-section">
    <ng-container *ngFor="let lineItem of lineItems; let i = index">
      <div
        [class.is-expanded]="selectedLineItemId === lineItem?.id"
        [class.is-active]="isActiveLineItem(lineItem?.id)"
        [attr.data-line-item-id]="lineItem?.id"
        class="line-item-accordion"
        (mouseenter)="onLineItemHover(lineItem?.id)"
        (mouseleave)="onLineItemHoverEnd()"
      >
        <!--        LINE ITEM HEADER SECTION       -->
        <div class="line-item-header flex justify-between items-center">
          <div
            (click)="selectLineItem(lineItem?.id)"
            class="left flex flex-row justify-start items-center gap-[12px] grow"
          >
            <div class="details">
              <div
                *ngIf="!lineItem?.sources?.length; else sourcesHeader"
                class="text-type-8"
              >
                {{ formatDateWithLowerAmPm(lineItem?.created_at) }}
              </div>
              <ng-template #sourcesHeader>
                <div
                  class="left flex flex-row justify-start items-center gap-[12px] grow"
                >
                  <div *ngIf="lineItem?.sources && lineItem?.sources.length;"
                       class="profile-image-section flex flex-row justify-center items-center">
                    <ng-container *ngIf="lineItem?.sources.length === 1;else multipleProfileImages">
                      <ng-container *ngIf="lineItem?.sources[0]?.source_inspector?.url;else avatar">
                        <img [src]="lineItem?.sources[0]?.source_inspector?.url" alt="image" class="image" />
                      </ng-container>
                      <ng-template #avatar>
                        <div
                          class="image avatar text-type-7 flex justify-center items-center">
                          {{ createAvatar(lineItem?.sources[0]?.source_inspector) }}
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-template #multipleProfileImages>
                      <div
                        class="multiple-profile-image-container flex flex-row justify-center items-center gap-[10px]">
                        <ng-container *ngIf="lineItem?.sources[0]?.source_inspector?.url;else avatar">
                          <img [src]="lineItem?.sources[0]?.source_inspector?.url" alt="image"
                               class="image first-profile image" />
                        </ng-container>
                        <ng-template #avatar>
                          <div
                            class="image first-profile image avatar text-type-7 flex justify-center items-center">
                            {{ createAvatar(lineItem?.sources[0]?.source_inspector) }}
                          </div>
                        </ng-template>
                        <div
                          class="image profile-counter text-type-7 flex justify-center items-center">
                          +{{ lineItem?.sources.length - 1 }}
                        </div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="details flex flex-col gap-[4px]">
                    <div class="heading">
                      {{ formatDateWithLowerAmPm(lineItem?.sourcesSection.heading) }}
                    </div>
                    <div class="subheading">
                      {{ lineItem?.sourcesSection.subheading }}
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="right flex justify-center items-center gap-[20px]">
            <span *ngIf="!!lineItem?.pay_app_id" class="paid-badge line-item-badge">PAID</span>
            <div class="chevron">
              <mat-icon
                (click)="selectLineItem(lineItem?.id)"
                [svgIcon]="selectedLineItemId === lineItem?.id ? 'chevron-up' : 'chevron-down'"
                class="chevron-icon"
              />
            </div>
            <div *ngIf="!disabled" class="menu-section">
              <mat-icon
                [matMenuTriggerFor]="menu"
               
                class="menu-icon"
              >more_horiz
              </mat-icon>
              <mat-menu #menu="matMenu">
                <button (click)="deleteLineItem(lineItem?.id)" [disabled]="!!lineItem?.pay_app_id" mat-menu-item>
                  <mat-icon [class.icon-disabled]="!!lineItem?.pay_app_id" svgIcon="trash" />
                  Delete line item
                </button>
              </mat-menu>
            </div>
          </div>
        </div>

        <ng-container *ngIf="lineItem?.sources?.length <= 1">

          <!--        LINE ITEM BODY        -->
          <div *ngIf="lineItem?.sourcesSection && !hasGpsGeometry(lineItem)" class="total-section flex flex-col">
            <div
              class="survey_data-map border h-[80px] my-[40px] rounded-[8px]"
            >
              <app-survey-data-map
                [data]="lineItem?.sourcesSection"
              />
            </div>
          </div>
          <!-- GPS Geometry Quantity Section -->
          <ng-container *ngIf="hasGpsGeometry(lineItem); else regularQuantitySection">
            <div [id]="lineItem?.id" class="line-item-content" (mouseleave)="!showMiniMaps && onGpsFeatureHoverEnd()">
              <!-- Clear selection button (only when a feature is selected) -->
              <div *ngIf="!showMiniMaps && selectedGpsFeatureKey && getGpsFeatures(lineItem).length > 1"
                   class="gps-clear-selection">
                <button class="clear-selection-btn" (click)="clearGpsFeatureSelection()">
                  <mat-icon class="clear-icon">clear_all</mat-icon>
                  <span>Clear selection</span>
                </button>
              </div>
              <!-- Per-feature sections -->
              <div *ngFor="let feature of getGpsFeatures(lineItem); let fi = index"
                   class="gps-feature-section"
                   [class.gps-feature-hovered]="hoveredGpsFeatureKey === lineItem?.id + '_' + fi"
                   [class.gps-feature-selected]="selectedGpsFeatureKey === lineItem?.id + '_' + fi"
                   [class.gps-feature-dimmed]="selectedGpsFeatureKey && selectedGpsFeatureKey !== lineItem?.id + '_' + fi"
                   (mouseenter)="!showMiniMaps && onGpsFeatureHover(lineItem?.id, fi)"
                   (click)="!showMiniMaps && onGpsFeatureClick(lineItem?.id, fi)"
              >
                <!-- Feature header for multi-feature -->
                <div *ngIf="getGpsFeatures(lineItem).length > 1"
                     class="text-[12px] text-[#60698B] font-semibold uppercase mb-[8px]">
                  Feature {{ fi + 1 }} - {{ featureTypeLabel(feature) }}
                </div>

                <!-- Per-feature mini map (hidden when map is showing geometries) -->
                <div *ngIf="showMiniMaps" class="survey_data-map border h-[80px] mb-[12px] rounded-[8px]">
                  <app-survey-data-map
                    [geometry]="lineItem?.geometry"
                    [highlightFeatureIndex]="fi"
                    (open3d)="openVolume3d(lineItem, $event.featureIndex)"
                  />
                </div>

                <!-- Device info -->
                <div class="flex flex-col gap-[4px] mb-[12px]">
                  @if (isVolume(feature)) {
                    <div class="flex justify-between text-[13px]">
                      <span class="text-[#60698B]">Volume</span>
                      <span>{{ volumeLabel(feature) }}</span>
                    </div>
                    <div class="flex justify-between text-[13px]">
                      <span class="text-[#60698B]">Points</span>
                      <span>{{ volumePoints(feature) }}</span>
                    </div>
                  }
                  <div *ngIf="feature.properties?.source?.meta?.receiverModel" class="flex justify-between text-[13px]">
                    <span class="text-[#60698B]">Device</span>
                    <span>{{ feature.properties.source.meta.receiverModel }}</span>
                  </div>
                  <div *ngIf="feature.properties?.source?.meta?.hrms != null || feature.properties?.source?.meta?.accuracy != null" class="flex justify-between text-[13px]">
                    <span class="text-[#60698B]">Accuracy</span>
                    <span>{{ formatGpsAccuracy(feature.properties.source.meta) }}</span>
                  </div>
                </div>

                @if (isVolume(feature)) {
                  <div class="gps-volume-actions">
                    <button type="button" class="view-3d-btn" [id]="'view-volume-3d-' + lineItem?.id + '-' + fi"
                            (click)="openVolume3d(lineItem, fi, $event)">
                      <mat-icon class="view-3d-icon">view_in_ar</mat-icon>
                      <span>View in 3D</span>
                    </button>
                  </div>
                }
                <!-- Quantity picklist -->
                <form [formGroup]="getFormGroup(form, lineItem?.id)">
                  <div class="fields-row each-item-quantity-block">
                    <app-dropdown
                      [label]="'Quantity (' + bidItem.uom + ')'"
                      [options]="gpsQuantityOptionsMap[lineItem?.id + '_' + fi]"
                      [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                      [controlName]="'gpsQuantityMode_' + fi"
                    />
                    <ng-container
                      *ngIf="getFormGroup(form, lineItem?.id)?.get('gpsQuantityMode_' + fi)?.value !== 'manual'; else gpsManualEntry"
                    >
                      <div class="quantity-section">
                        <div class="spacer h-[30px]"></div>
                        <div class="disabled-quantity-value text-type-11">
                          {{ getGpsDisplayQuantity(lineItem?.id, fi) | number: '1.0-' + (bidItem?.quantity_rounding ?? 2) }}
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #gpsManualEntry>
                      <app-number-input
                        [decimalPlaces]="bidItem?.quantity_rounding ?? 2"
                        [isDecimalAllowed]="true"
                        [min]="-9999999999"
                        [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                        [controlName]="getGpsFeatures(lineItem).length > 1 ? 'gpsQuantity_' + fi : 'quantity'"
                        [hint]="getGpsMeasuredQtyHint(lineItem?.id, fi)"
                      />
                    </ng-template>
                  </div>
                  <!-- Rollup fields (length, width, etc.) per feature -->
                  <div *ngIf="bidItem?.rollup" class="fields-row input-block">
                    <ng-container *ngFor="let field of bidItem.fields">
                      <ng-container *ngIf="field.type === 'number' || false">
                        <app-number-input
                          [controlName]="field.id + '_' + fi"
                          [disabled]="!!lineItem?.pay_app_id"
                          [isDecimalAllowed]="true"
                          [label]="field.label + ' (' + field.uom + ')'"
                          [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                        />
                      </ng-container>
                    </ng-container>
                  </div>
                </form>
              </div>
            </div>
          </ng-container>

          <!-- Regular (non-GPS) Quantity Section -->
          <ng-template #regularQuantitySection>
            <!-- GPS Measurements (legacy display for items that somehow have GPS data but aren't full GPS geometry) -->
            <div *ngIf="getGpsMeasurements(lineItem)?.length" class="px-[16px] pb-[8px]">
              <div *ngFor="let gps of getGpsMeasurements(lineItem)" class="flex flex-col gap-[4px] mb-[8px]">
                <div *ngIf="gps.modified_fields?.length_f" class="flex justify-between text-[13px]">
                  <span class="text-[#60698B]">Length (ft)</span>
                  <span>{{ gps.modified_fields.length_f | number:'1.2-2' }}</span>
                </div>
                <div *ngIf="gps.modified_fields?.width_f" class="flex justify-between text-[13px]">
                  <span class="text-[#60698B]">Width (ft)</span>
                  <span>{{ gps.modified_fields.width_f | number:'1.2-2' }}</span>
                </div>
                <div *ngIf="gps.modified_fields?.area_f" class="flex justify-between text-[13px]">
                  <span class="text-[#60698B]">Area (sq ft)</span>
                  <span>{{ gps.modified_fields.area_f | number:'1.2-2' }}</span>
                </div>
                <div *ngIf="gps.meta?.receiverModel" class="flex justify-between text-[13px]">
                  <span class="text-[#60698B]">Device</span>
                  <span>{{ gps.meta.receiverModel }}</span>
                </div>
                <div *ngIf="gps.meta?.hrms != null || gps.meta?.accuracy != null" class="flex justify-between text-[13px]">
                  <span class="text-[#60698B]">Accuracy</span>
                  <span>{{ formatGpsAccuracy(gps.meta) }}</span>
                </div>
              </div>
            </div>
            <ng-container *ngIf="stationRangeDisplayByLineItemId[lineItem?.id] as stationDisplay">
              <div *ngIf="stationDisplay.hasLocationOrStation" class="location-station-card">
                <div class="location-station-header">
                  <div class="location-station-label">LOCATION / STATION:</div>
                  <button
                    *ngIf="!disabled"
                    type="button"
                    class="clear-location-station-button"
                    (click)="deleteLocation(lineItem?.id)"
                    aria-label="Clear location or station range"
                  >
                    <mat-icon svgIcon="trash"></mat-icon>
                  </button>
                </div>
                <div class="location-station-box">
                  <ng-container *ngIf="stationDisplay.stationRangeMapData as stationRangeMapData">
                    <div
                      class="station-range-map-section cursor-pointer"
                    >
                      <!-- Spec addendum §11: a linked line's capture takes the map's slot; the FROM / TO labels stay over it. -->
                      @if (hasCapture(stationDisplay.mapFeatureLink)) {
                        <!-- Opens the full picture, read-only hosts (the map side panel) too; the card's "Edit location" opens the picker. -->
                        <app-design-capture-preview
                          [link]="stationDisplay.mapFeatureLink"
                          height="80px"
                          [viewOnClick]="true"
                        />
                      } @else {
                        <app-survey-data-map
                          [geometry]="stationRangeMapData.geometry"
                          (mapClicked)="openLocationStationCard(lineItem?.id, stationDisplay)"
                        />
                      }
                      <div *ngIf="stationRangeMapData.fromLabel" class="station-map-label station-map-label-from">
                        {{ stationRangeMapData.fromLabel }}
                      </div>
                      <div *ngIf="stationRangeMapData.toLabel" class="station-map-label station-map-label-to">
                        {{ stationRangeMapData.toLabel }}
                      </div>
                    </div>
                    </ng-container>

                  <ng-container *ngIf="stationDisplay.currentStationRange as currentStationRange">
                    <div *ngIf="currentStationRange.alignment" class="station-detail-block">
                      <div class="station-range-sub-section-label">Alignment</div>
                      <div class="station-detail-value">{{ currentStationRange.alignment }}</div>
                    </div>
                    <div
                      *ngIf="currentStationRange.from?.station || currentStationRange.from?.offsetType || currentStationRange.from?.offsetDistance"
                      class="station-detail-block"
                    >
                      <div class="station-range-sub-section-label">From</div>
                      <div class="station-detail-value">
                        {{ currentStationRange.from?.station }}
                        <span *ngIf="currentStationRange.from?.offsetType">, {{ currentStationRange.from?.offsetType }}</span>
                        <span *ngIf="currentStationRange.from?.offsetDistance">, {{ currentStationRange.from?.offsetDistance }}</span>
                      </div>
                    </div>
                    <div
                      *ngIf="currentStationRange.to?.station || currentStationRange.to?.offsetType || currentStationRange.to?.offsetDistance"
                      class="station-detail-block"
                    >
                      <div class="station-range-sub-section-label">To</div>
                      <div class="station-detail-value">
                        {{ currentStationRange.to?.station }}
                        <span *ngIf="currentStationRange.to?.offsetType">, {{ currentStationRange.to?.offsetType }}</span>
                        <span *ngIf="currentStationRange.to?.offsetDistance">, {{ currentStationRange.to?.offsetDistance }}</span>
                      </div>
                    </div>
                  </ng-container>

                  <div
                    *ngIf="stationDisplay.locationText"
                    class="station-detail-block"
                    [class.cursor-pointer]="!stationDisplay.currentStationRange"
                    (click)="!stationDisplay.currentStationRange && openLocationPickerForLineItem(lineItem?.id)"
                  >
                    <div class="station-range-sub-section-label">Location</div>
                    <div class="station-detail-value">{{ stationDisplay.locationText }}</div>
                  </div>

                  <div
                    *ngIf="stationDisplay.mapFeatureLink"
                    class="station-detail-block"
                    data-testid="location-card-design-context"
                    role="group"
                    aria-label="Design context"
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                  >
                    <app-design-context
                      [link]="stationDisplay.mapFeatureLink"
                      [collapseWhenCaptured]="true"
                      [editable]="!disabled"
                      [projectId]="projectId"
                      (remove)="removeDesignContext(lineItem?.id)"
                      (editLocation)="openLocationStationCard(lineItem?.id, stationDisplay)"
                      (linkChange)="setDesignContext(lineItem?.id, $event)"
                    ></app-design-context>
                  </div>
                </div>
              </div>
            </ng-container>
            <div [id]="lineItem?.id" class="line-item-content">
              <!--          ROLL UP FALSE SECTION          -->
              <ng-container *ngIf="bidItem?.rollup === false; else allowRollup">
                <form [formGroup]="getFormGroup(form, lineItem?.id)">
                  <app-number-input
                    [decimalPlaces]="bidItem?.quantity_rounding ?? 2"
                    [disabled]="!!lineItem?.pay_app_id"
                    [isDecimalAllowed]="true"
                    [label]="'Quantity (' + bidItem.uom + ')'"
                    [min]="-9999999999"
                    [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                    class="each-item-quantity-block"
                    controlName="quantity"
                  />
                </form>
              </ng-container>
              <!--          ROLL UP SECTION          -->
              <ng-template #allowRollup>
                <!--          ROLL UP QUANTITY EDITABLE FALSE SECTION          -->
                <ng-container *ngIf="bidItem?.rollup_quantity_editable === false; else allowEditableRollup">

                  <ng-container *ngIf="isFormReady">
                    <form
                      [formGroup]="getFormGroup(form, lineItem?.id)"
                    >
                      <div class="quantity-section each-item-quantity-block">
                        <div class="disabled-quantity-label text-type-13">QUANTITY ({{ bidItem.uom }}):</div>
                        <div class="disabled-quantity-value text-type-11">{{
                            getFormGroup(form,
                              lineItem?.id).controls?.quantity.value
                          }}
                        </div>
                      </div>
                      <div class="fields-row input-block">
                        <ng-container *ngFor="let field of bidItem.fields">
                          <ng-container *ngIf="field.type === 'number' || false">
                            <app-number-input
                              [controlName]="field.id"
                              [disabled]="!!lineItem?.pay_app_id"
                              [isDecimalAllowed]="true"
                              [label]="field.label + ' (' + field.uom + ')'"
                              [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                            />
                          </ng-container>
                        </ng-container>
                      </div>
                    </form>
                  </ng-container>
                </ng-container>
                <!--          ROLL UP QUANTITY EDITABLE SECTION          -->
                <ng-template #allowEditableRollup>
                  <ng-container *ngIf="isFormReady">
                    <form [formGroup]="getFormGroup(form, lineItem?.id)">
                      <div class="fields-row each-item-quantity-block">
                        <app-dropdown
                          [label]="'QUANTITY (' + bidItem.uom + ')'"
                          [options]="autoCalculateOptions"
                          [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                          controlName="valueType"
                        />
                        <ng-container
                          *ngIf="getFormGroup(form, lineItem?.id)?.controls?.valueType?.value ===
                        'dynamic_rollup'; else manualEntry"
                        >
                          <div class="quantity-section">
                            <div class="spacer h-[30px]"></div>
                            <div class="disabled-quantity-value text-type-11">{{
                                getFormGroup(form,
                                  lineItem?.id).controls?.quantity?.value
                              }}
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #manualEntry>
                          <app-number-input
                            [decimalPlaces]="bidItem?.quantity_rounding ?? 2"
                            [disabled]="!!lineItem?.pay_app_id"
                            [isDecimalAllowed]="true"
                            [min]="-9999999999"
                            [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                            controlName="quantity"
                          />
                        </ng-template>
                      </div>
                      <div class="fields-row input-block">
                        <ng-container *ngFor="let field of bidItem.fields">
                          <ng-container *ngIf="field.type === 'number' || false">
                            <app-number-input
                              [controlName]="field.id"
                              [disabled]="!!lineItem?.pay_app_id"
                              [isDecimalAllowed]="true"
                              [label]="field.label + ' (' + field.uom + ')'"
                              [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                            />
                          </ng-container>
                        </ng-container>
                      </div>
                    </form>
                  </ng-container>
                </ng-template>
              </ng-template>
            </div>
          </ng-template>
        </ng-container>


        <div *ngIf="lineItem?.sources?.length > 1">
          <!--        LINE ITEM BODY        -->
          <div class="total-section flex flex-col">
            <div class="survey_data-map border h-[80px] my-[40px] rounded-[8px]">
              <app-survey-data-map
                [data]="lineItem?.sourcesSection"
              />
            </div>
          </div>
          <form
            *ngIf="bidItem?.rollup_quantity_editable === true"
            [formGroup]="getFormGroup(form, lineItem?.id)">
            <div class="fields-row each-item-quantity-block">
              <app-dropdown
                [label]="'QUANTITY (' + bidItem.uom + ')'"
                [options]="autoCalculateOptions"
                [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                controlName="valueType"
              />
              <ng-container
                *ngIf="getFormGroup(form, lineItem?.id)?.controls?.valueType?.value ===
                      'dynamic_rollup'; else manualEntry"
              >
                <div class="quantity-section">
                  <div class="spacer h-[30px]"></div>
                  <div class="disabled-quantity-value text-type-11">{{
                      getFormGroup(form,
                        lineItem?.id).controls?.quantity?.value
                    }}
                  </div>
                </div>
              </ng-container>
              <ng-template #manualEntry>
                <app-number-input
                  [decimalPlaces]="bidItem?.quantity_rounding ?? 2"
                  [disabled]="!!lineItem?.pay_app_id"
                  [hint]="'Calculated: ' + calculatedValues[lineItem?.id]"
                  [isDecimalAllowed]="true"
                  [min]="-9999999999"
                  [parentFormGroup]="getFormGroup(form, lineItem?.id)"
                  controlName="quantity"
                />
              </ng-template>
            </div>
          </form>
          <div
            *ngIf="bidItem?.rollup_quantity_editable === false">
            <div class="total-section flex flex-col">
              <div class="quantity-total-label text-type-14">QUANTITY:</div>
              <div
                class="quantity-total-value text-type-11">{{ quantityTotal | number: '1.0-' + (bidItem?.quantity_rounding ?? 2) }}
              </div>
            </div>
          </div>
          <ng-container *ngFor="let source of lineItem?.sourcesSection.sourcesList">

            <div
              [class.rollup-false]='bidItem?.rollup === false'
              [id]="source.id"
              class="line-item-content"
            >
              <!--          ROLL UP FALSE SECTION          -->
              <ng-container *ngIf="bidItem?.rollup === false; else allowRollup">
                <div class="inspector-info flex flex-row justify-start items-center gap-[12px] grow mb-[20px]">
                  <div class="profile-image-section flex flex-row justify-center items-center">
                    <ng-container *ngIf="source?.source_inspector?.url;else avatar">
                      <img [src]="source?.source_inspector?.url" alt="image" class="image" />
                    </ng-container>
                    <ng-template #avatar>
                      <div
                        class="image avatar text-type-7 flex justify-center items-center">
                        {{ createAvatar(source?.source_inspector) }}
                      </div>
                    </ng-template>
                  </div>
                  <div class="details text-type-14">
                    <div class="source-heading">
                      {{ source.source_created_at| date: 'hh:mm a' }}
                    </div>
                    <div class="source-subheading">
                      {{ source?.source_inspector }}
                    </div>
                  </div>
                </div>
                <form [formGroup]="getFormGroup(form, lineItem?.id+ '_' +source.id)">
                  <app-number-input
                    [decimalPlaces]="bidItem?.quantity_rounding ?? 2"
                    [disabled]="!!lineItem?.pay_app_id"
                    [isDecimalAllowed]="true"
                    [label]="'Quantity (' + bidItem.uom + ')'"
                    [min]="-9999999999"
                    [parentFormGroup]="getFormGroup(form, lineItem?.id+ '_' +source.id)"
                    class="each-item-quantity-block"
                    controlName="quantity"
                  />
                </form>
              </ng-container>
              <!--          ROLL UP SECTION          -->
              <ng-template #allowRollup>
                <!--          ROLL UP QUANTITY EDITABLE FALSE SECTION          -->
                <ng-container *ngIf="bidItem?.rollup_quantity_editable === false; else allowEditableRollup">

                  <ng-container *ngIf="isFormReady">
                    <form
                      [formGroup]="getFormGroup(form, lineItem?.id+ '_' +source.id)"
                    >
                      <div class="fields-row input-block">
                        <ng-container *ngFor="let field of bidItem.fields">
                          <ng-container *ngIf="field.type === 'number' || false">
                            <app-number-input
                              [controlName]="field.id"
                              [disabled]="!!lineItem?.pay_app_id"
                              [isDecimalAllowed]="true"
                              [label]="field.label + ' (' + field.uom + ')'"
                              [parentFormGroup]="getFormGroup(form, lineItem?.id+ '_' +source.id)"
                            />
                          </ng-container>
                        </ng-container>
                      </div>
                    </form>
                  </ng-container>
                </ng-container>
                <!--          ROLL UP QUANTITY EDITABLE SECTION          -->
                <ng-template #allowEditableRollup>
                  <ng-container *ngIf="isFormReady">
                    <form [formGroup]="getFormGroup(form, lineItem?.id+ '_' +source.id)">
                      <div class="fields-row input-block">
                        <div class="quantity-section">
                          <div class="disabled-quantity-label text-type-13 !text-[11px] mt-[5px] !pb-[7px] "
                          >
                            QUANTITY ({{ bidItem.uom }}):
                          </div>
                          <div class="disabled-quantity-value text-type-11">{{
                              getFormGroup(form,
                                lineItem?.id + '_' + source.id).controls?.quantity?.value
                            }}
                          </div>
                        </div>
                        <ng-container *ngFor="let field of bidItem.fields">
                          <ng-container *ngIf="field.type === 'number' || false">
                            <app-number-input
                              [controlName]="field.id"
                              [disabled]="!!lineItem?.pay_app_id"
                              [isDecimalAllowed]="true"
                              [label]="field.label + ' (' + field.uom + ')'"
                              [parentFormGroup]="getFormGroup(form, lineItem?.id+ '_' +source.id)"
                            />
                          </ng-container>
                        </ng-container>
                      </div>
                    </form>
                  </ng-container>
                </ng-template>
              </ng-template>
            </div>
          </ng-container>
        </div>

        <form [formGroup]="getFormGroup(form, lineItem?.id)">
          <div
            *ngIf="!!getFormGroup(form, lineItem?.id).controls?.comment"
            class="comment-section"
          >
            <app-text-area
              [parentFormGroup]="getFormGroup(form, lineItem?.id)"
              controlName="comment"
              label="COMMENT"
            />
          </div>
          <app-pictures-section
            (onDelete)="!disabled && deletePicture($event)"
            *ngIf="selectedLineItemMediaFiles.length && selectedLineItemId === lineItem?.id"
            [isEditable]="!disabled"
            [pictures]="selectedLineItemMediaFiles"
            [selectedLineItem]="selectedLineItem"
            class="pictures-section"
          />
          <app-location-section
            (onDelete)="!disabled && deleteLocation(lineItem?.id)"
            (click)="openLocationPickerForLineItem(lineItem?.id)"
            *ngIf="showLocationSection(lineItem?.id)"
            [isEditable]="!disabled"
            [latitude]="getFormGroup(form, lineItem?.id)?.controls?.latitude?.value"
            [longitude]="getFormGroup(form, lineItem?.id)?.controls?.longitude?.value"
            [mapFeatureLink]="stationRangeDisplayByLineItemId[lineItem?.id]?.mapFeatureLink"
            class="location-section"
          />
        </form>
      </div>
    </ng-container>
  </div>
</div>
